import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=0fdecea3&scoped=true&"
import script from "./ImageUploader.vue?vue&type=script&lang=ts&"
export * from "./ImageUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=0fdecea3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdecea3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdecea3')) {
      api.createRecord('0fdecea3', component.options)
    } else {
      api.reload('0fdecea3', component.options)
    }
    module.hot.accept("./ImageUploader.vue?vue&type=template&id=0fdecea3&scoped=true&", function () {
      api.rerender('0fdecea3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageUploader/ImageUploader.vue"
export default component.exports